import { render } from "./ProgressBar.vue?vue&type=template&id=28979072"
import script from "./ProgressBar.vue?vue&type=script&lang=js"
export * from "./ProgressBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/usage/ProgressBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28979072"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28979072', __exports__)) {
    api.reload('28979072', __exports__)
  }
  
  module.hot.accept("./ProgressBar.vue?vue&type=template&id=28979072", () => {
    api.rerender('28979072', render)
  })

}


export default __exports__